import API, { ensurePrefixed } from 'utils/api';
import { onError } from 'utils/handlers';
import getFormattedValues from 'utils/formatValues';

export const baseURI = 'usuarios/';

/**
 * POST Login
 * @param {object} values
 * @returns {Promise<object>}
 */
export const login = async (_values, accion = 'LOGIN') => {
  try {
    const values = getFormattedValues(_values);
    const accionInf = ensurePrefixed('', accion);
    const response = await API.post(`${baseURI}login`, values, { accionInf });
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Informacion de Usuario
 * @param {string} access Access token
 * @returns {Promise<object>}
 */
export const getUserInfo = async (access = null) => {
  try {
    const config = access ? {
      headers: {
        authorization: `Bearer ${access}`,
      },
    } : null;
    const response = await API.get(`${baseURI}id`, config);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Verificacion de Correo Electronico
 * @param {string} codigo
 * @returns {Promise<object>}
 */
export const verificarEmail = async (codigo) => {
  try {
    const response = await API.get(`usuarios/verificar-email?codigo=${codigo}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Cancelar Restablecer Contraseña
 * @param {string} codigo
 * @returns {Promise<object>}
 */
export const cancelarRestablecerContrasena = async (codigo) => {
  try {
    const response = await API.get(`usuarios/cancelar-restablecer-contrasena?codigo=${codigo}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Cancelar Restablecer Contraseña
 * @param {string} codigo
 * @param {object} values
 * @returns {Promise<object>}
 */
export const restablecerContrasena = async (codigo, values) => {
  try {
    const response = await API.post(`usuarios/restablecer-contrasena?codigo=${codigo}`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Solicitarr Restablecer Contrasena
 * @param {string} codigo
 * @returns {Promise<object>}
 */
export const solicitarRestablecerContrasena = async (values) => {
  try {
    const response = await API.post('usuarios/solicitud-restablecer-contrasena', values);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
